export default __webpack_public_path__ + "static/media/deposit-gpay-step2.fd736bc3.png";